import { VesselFieldDisplayConfigState } from './types'

export const vesselFieldDisplayConfigSelector = (state: any): VesselFieldDisplayConfigState =>
  state.vesselFieldDisplay
